module.exports = __webpack_public_path__ + "img/knife1.cb332cb4.png";